/* import __COLOCATED_TEMPLATE__ from './buyer-invoices.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { EMBER_ROUTE_NAMES } from 'sh-www/constants/routes';
import { showModal } from 'sh-www/utils/modal-controls';
import { absoluteStoryhunterUrl } from 'sh-www/utils/url';

const CLASS_NAME = 'SH-c-reports-buyer-invoices';

const DUE = 'Due';
const PAID = 'Paid';
const OVERDUE = 'Overdue';

const PAYMENT_STATUS_OPTIONS = [
  OVERDUE,
  DUE,
  PAID,
];

class BuyerInvoicesReport extends Component {
  @service constants;
  @service media;
  @service router;
  @service session;

  @tracked selectedShInvoice = null;

  get className() {
    return CLASS_NAME;
  }

  get company() {
    return this.session.currentUser.company;
  }

  get applyCreditOnInvoiceDisabledMap() {
    const balanceExists = Object.values(this.args.costCodeToCreditRemainingInCents).some((balance) => balance > 0);
    return this.args.shInvoices.reduce((accum, shInvoice) => {
      accum[shInvoice.id] = !balanceExists || shInvoice.isPaid;
      return accum;
    }, {});
  }

  get shouldHideColumn() {
    return this.media.isMediumAndDown;
  }

  get factoidsMap() {
    return this.args.invoiceFactoids.reduce((accum, factoid) => {
      accum[factoid.title] = factoid.fact;
      return accum;
    }, {});
  }

  @action
  onDownloadClicked(shInvoice) {
    window.open(absoluteStoryhunterUrl(`/sh-invoices/${shInvoice.id}/pdf`));
  }

  @action
  onApplyCreditClicked(shInvoice) {
    const {
      costCodeOptions,
      currentPage,
      reloadCodeCreditsTask,
      reloadFactoidsTask,
      reloadPageTask,
    } = this.args;

    showModal(this, 'reports/apply-credit-to-invoice-modal', {
      costCodes: costCodeOptions,
      currentPage,
      reloadCodeCreditsTask,
      reloadFactoidsTask,
      reloadPageTask,
      shInvoice,
    });
  }


  @action
  onClearDetailsClicked() {
    this.selectedShInvoice = null;
  }

  @action
  onProjectViewListClicked(shInvoice) {
    if (shInvoice.isBatchedInvoice) {
      showModal(this, 'reports/batched-invoice-breakdown-modal', {
        shInvoice,
      });
    } else {
      this.router.transitionTo(EMBER_ROUTE_NAMES.PROJECT__DETAILS__ACTIVITY, shInvoice.applicationId);
    }
  }

  @action
  onViewDetailsClicked(shInvoice) {
    this.selectedShInvoice = shInvoice;
  }
}

export default BuyerInvoicesReport;
